// extracted by mini-css-extract-plugin
export default {"socialButton":"SocialButton_socialButton"};